var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: { "label-position": "top" },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientName") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveName",
                      "encrypted-value": _vm.ruleForm.receiveName,
                      label: _vm.$t("newOrder.RecipientName"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientCompany") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveCompany",
                      "encrypted-value": _vm.ruleForm.receiveCompany,
                      label: _vm.$t("newOrder.RecipientCompany"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.Recipientphone") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveMobile",
                      "encrypted-value": _vm.ruleForm.receiveMobile,
                      label: _vm.$t("newOrder.Recipientphone"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("driver.modalStreet") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveStreet",
                      "encrypted-value": _vm.ruleForm.receiveStreet,
                      label: "receiveStreet",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.doorNumber") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveHouseNumber",
                      "encrypted-value": _vm.ruleForm.receiveHouseNumber,
                      label: "receiveHouseNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientDistrict") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveArea",
                      "encrypted-value": _vm.ruleForm.receiveArea,
                      label: "receiveArea",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientCity") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveCity",
                      "encrypted-value": _vm.ruleForm.receiveCity,
                      label: "receiveCity",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientState") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveState",
                      "encrypted-value": _vm.ruleForm.receiveState,
                      label: "receiveState",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientZipCode") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveZipcode",
                      "encrypted-value": _vm.ruleForm.receiveZipcode,
                      label: "receiveZipcode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("GlobalSetObj.recipientComplement") },
                },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveComplement",
                      "encrypted-value": _vm.ruleForm.receiveComplement,
                      label: _vm.$t("GlobalSetObj.recipientComplement"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientCPF") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveTax",
                      "encrypted-value": _vm.ruleForm.receiveTax,
                      label: _vm.$t("newOrder.RecipientCPF"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.receiveIe") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveIeNumber",
                      "encrypted-value": _vm.ruleForm.receiveIeNumber,
                      label: "receiveIeNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.ReceivingAddress") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveAddress",
                      "encrypted-value": _vm.ruleForm.receiveAddress,
                      label: _vm.$t("newOrder.ReceivingAddress"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.Recipientphonenumber") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receivePhone",
                      "encrypted-value": _vm.ruleForm.receivePhone,
                      label: _vm.$t("newOrder.Recipientphonenumber"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.RecipientEmail") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "receiveMail",
                      "encrypted-value": _vm.ruleForm.receiveMail,
                      label: _vm.$t("newOrder.RecipientEmail"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }